<div title="{{tooltip}}">
  @if (status=='None') {
    <svg class="icon none" viewBox="0 0 24 28">
      <use xmlns:xlink="http://www.w3.org/1999/xlink" xlink:href="/css/svg/icons.svg#circle-minus"></use>
    </svg>
  }
  @if (status=='Ok') {
    <svg class="icon ok" viewBox="0 0 24 28">
      <use xmlns:xlink="http://www.w3.org/1999/xlink" xlink:href="/css/svg/icons.svg#check-circle-o"></use>
    </svg>
  }
  @if (status=='Warning') {
    <svg class="icon warning" viewBox="0 0 24 28">
      <use xmlns:xlink="http://www.w3.org/1999/xlink" xlink:href="/css/svg/icons.svg#dot-circle-o"></use>
    </svg>
  }
  @if (status=='Error' || status=='Failed') {
    <svg class="icon error" viewBox="0 0 24 28">
      <use xmlns:xlink="http://www.w3.org/1999/xlink" xlink:href="/css/svg/icons.svg#times-circle-o"></use>
    </svg>
  }
  @if (status=='Pause') {
    <svg class="icon warning" viewBox="0 0 28 28">
      <use xmlns:xlink="http://www.w3.org/1999/xlink" xlink:href="/css/svg/icons.svg#info-circle"></use>
    </svg>
  }
</div>
